<ix-modal-header>{{
  'dpp.passport_overview.add_passport' | translate
}}</ix-modal-header>
<ix-modal-content>
  <form [formGroup]="dppForm">
    <ix-input
      class="w-100 mb-3"
      [label]="'dpp.general.aas_id' | translate"
      [helperText]="'dpp.modal.aas_id_helper_text' | translate"
      formControlName="aasId"
      id="aasId"
    ></ix-input>

    <ix-input
      class="w-100 mb-3"
      [label]="'dpp.general.global_asset_id' | translate"
      formControlName="globalAssetId"
      id="globalAssetId"
    ></ix-input>

    <ix-input
      class="w-100 mb-3"
      [label]="'dpp.general.passport_name' | translate"
      placeholder=""
      formControlName="passportName"
      id="passportName"
    ></ix-input>

    <ix-typography class="my-3" format="label" id="assetImageUploadLabel">
      {{ 'dpp.modal.upload_picture_label' | translate }}
    </ix-typography>
    <ix-upload
      (filesChanged)="onFilesChanged($event)"
      accept="image/png, image/jpeg"
      id="assetImageUpload"
      [state]="uploadState"
      [selectFileText]="'dpp.modal.upload_drag_text' | translate"
      [i18nUploadFile]="'dpp.modal.upload_file_placeholder' | translate"
      [loadingText]="'dpp.modal.upload_loading_text' | translate"
      [uploadFailedText]="
        'dpp.modal.upload_failed'
          | translate: {error_message: uploadErrorMessage}
      "
      [uploadSuccessText]="'dpp.modal.upload_success' | translate"
    ></ix-upload>
    @if (selectedFile) {
      <ix-typography class="mt-2" format="caption">
        {{ 'dpp.modal.file_selected' | translate: {name: selectedFile.name} }}
      </ix-typography>
    }
  </form>
</ix-modal-content>

<ix-modal-footer>
  <ix-button
    variant="secondary"
    class="dismiss-modal"
    id="cancelButton"
    (click)="onCancel()"
    [disabled]="isSubmitting"
    onkeypress=""
  >
    {{ 'general.cancel' | translate }}
  </ix-button>
  <ix-button
    class="dismiss-modal"
    id="addButton"
    (click)="onSubmit()"
    [disabled]="isAddButtonDisabled()"
    [loading]="isSubmitting"
    onkeypress=""
  >
    {{ 'general.add' | translate }}
  </ix-button>
</ix-modal-footer>
